(ns shared.core.amelia-light.components.panel
  (:require ["@up/extended-ui/components/panel/panel-layout" :default PanelLayout :refer [PanelLeft PanelRight]]
            ["@up/extended-ui/components/panel/panel-header" :default PanelHeader :refer [PanelHeaderProperty PanelHeaderUpsert]]
            ["@up/extended-ui/components/panel/panel-grid" :default PanelGrid]))

(defn up-panel-layout [& args] (into [:> PanelLayout] args))
(defn up-panel-left [& args] (into [:> PanelLeft] args))
(defn up-panel-right [& args] (into [:> PanelRight] args))
(defn up-panel-header [& args] (into [:> PanelHeader] args))
(defn up-panel-header-property [& args] (into [:> PanelHeaderProperty] args))
(defn up-panel-header-upsert [& args] (into [:> PanelHeaderUpsert] args))
(defn up-panel-grid [& args] (into [:> PanelGrid] args))
